<template>
  <v-container fluid class="px-0">
    <v-row class="mb-3">
      <v-col cols="12" md="6">
        <el-text-field
          label="Identifikavimo numeris suteiktas gamintojo (VIN kodas)"
          tooltip="Hipoteka. Turtas. Transporto priemonė. Identifikavimo numeris"
          need
          :readonly="vinKodasReadonly"
          :counter="20"
          v-model="formData.tur_identifikatorius"
          :autofocus="!vinKodasReadonly"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Valstybinis numeris"
          tooltip="Hipoteka. Turtas. Transporto priemonė. Valstybinis numeris"
          need
          :readonly="turtasReadonly"
          :counter="10"
          v-model="formData.tur_ktp_valstybinis_numeris"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Registracijos dokumento numeris"
          tooltip="Hipoteka. Turtas. Transporto priemonė. Registracijos dokumento numeris"
          need
          :readonly="turtasReadonly"
          :counter="10"
          v-model="formData.tur_ktp_registracijos_numeris"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Tipo pavadinimas"
          tooltip="Hipoteka. Turtas. Transporto priemonė. Tipo pavadinimas"
          need
          :readonly="turtasReadonly"
          :counter="80"
          v-model="formData.tur_ktp_tipas"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Gamybinė markė arba modelis"
          tooltip="Hipoteka. Turtas. Transporto priemonė. Gamybinė markė arba modelis"
          need
          :readonly="turtasReadonly"
          :counter="100"
          v-model="formData.tur_ktp_modelis"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="TP ID"
          tooltip="Hipoteka. Turtas. Transporto priemonė. TP ID"
          :readonly="turtasReadonly"
          :counter="10"
          v-model="formData.tur_ktp_tp_id"
        />
      </v-col>
      <template v-if="showAplinkybe">
        <v-col cols="12" md="6">
          <el-checkbox
            class="mb-3 mt-0"
            label="Išregistruota"
            tooltip="Hipoteka. Turtas. Transporto priemonė. Išregistruota"
            :readonly="turtasReadonly"
            v-model="formData.tur_ktp_isregistruotas"
          />
        </v-col>
        <v-col cols="12" md="12">
          <el-textarea
            label="Aplinkybė"
            tooltip="Hipoteka. Turtas. Transporto priemonė. Aplinkybė"
            :readonly="turtasReadonly"
            v-model="formData.tur_ktp_aplinkybe"
          />
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TurtasKTP',
  props: {
    formData: Object,
    readonly: Boolean,
    irasomas: Boolean,
    sudarymas: Boolean,
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    turtasReadonly() {
      return this.readonly || !(this.irasomas || this.isTpsais)
    },
    vinKodasReadonly() {
      return this.readonly || !this.irasomas || !this.sudarymas
    },
    showAplinkybe() {
      return this.formData.tur_ktp_isregistruotas
    },
    isKtpr() {
      return this.formData.tur_ktp_sistema === 'ktpr'
    },
    isTpsais() {
      return this.formData.tur_ktp_sistema === 'tpsais'
    },
  },
}
</script>
